import React from "react";
import Model from "../Model";
import tw from "tailwind-styled-components";
import { SubmitBtn } from "../Styles/InputStyles";
import Loading from "../Loading";

const DownloadPV = ({
  selectedData,
  setDownloadPv,
  downloadPvMutate,
  downloadPvLoading,
}) => {
  return (
    <Model width="w-11/12 max-w-lg" setOpenModel={setDownloadPv}>
      {downloadPvLoading ? (
        <Loading />
      ) : (
        <>
          <Title className="text-center">Download PV</Title>

          <h2 className="text-sm md:text-lg text-gray-600 font-medium mt-3">
            Police Verification File
          </h2>

          <p className="text-xs md:text-sm text-gray-600 mb-4">
            Click the button below to download the police verification file.
          </p>

          <div className="bg-blue-200 p-4 rounded">
            <h3 className="text-sm font-semibold mb-2 text-gray-600">
              Download File
            </h3>

            <div className="flex justify-between items-center gap-4">
              <div className="text-sm text-gray-600">
                File will be generated for the selected owner.
              </div>

              <SubmitBtn
                className="bg-white rounded px-4 py-2 hover:bg-blue-700 text-gray-600 hover:text-white"
                onClick={() =>
                  downloadPvMutate({ clientId: selectedData?.id })
                }
              >
                Download
              </SubmitBtn>
            </div>
          </div>
        </>
      )}
    </Model>
  );
};

const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6`;

export default DownloadPV;
